export enum Direction {
    Up = 1,
    Down,
    Left,
    Right,
}